import websdk from 'easemob-websdk'

// TODO: Replace with your actual App Key
const TEST_APP_KEY = 'alexma78818#ytxapp-jc-test' 
const TEST_API_URL = 'https://a1.easemob.com'
const APP_KEY = 'alexma78818#ytxapp' 
const API_URL = 'https://a1-vip6.easemob.com'

let conn: any = null

export const initIM = () => {
  if (conn) return conn

  const isTest = window.location.hostname.includes('test') || window.location.hostname.includes('localhost')
  const currentAppKey = isTest ? TEST_APP_KEY : APP_KEY
  const currentApiUrl = isTest ? TEST_API_URL : API_URL

  conn = new websdk.connection({
    appKey: currentAppKey,
    isMultiLoginSessions: true,
    https: true,
    // url: 'wss://im-api-v2.easemob.com/ws',
    // apiUrl: currentApiUrl,
    autoReconnectNumMax: 2,
    autoReconnectInterval: 2,
    isAutoLogin: true
  })

  // Add listeners
  conn.listen({
    onOpened: function () {
      console.log('IM connected successfully')
    },
    onClosed: function () {
      console.log('IM disconnected')
    },
    onTextMessage: function (message: any) {
      console.log('Received text message:', message)
      // Dispatch event so components can listen
      window.dispatchEvent(new CustomEvent('on-im-message', { detail: message }))
    },
    onRecallMessage: function (message: any) {
      console.log('Message recall:', message)
      window.dispatchEvent(new CustomEvent('on-im-message-recall', { detail: message }))
    },
    onError: function (error: any) {
      console.error('IM error:', error)
      // 检测用户被踢下线的错误
      const errorStr = JSON.stringify(error).toLowerCase()
      const errorMsg = (error.message || error.data || '').toString().toLowerCase()
      if (
        errorStr.includes('already logged') ||
        errorStr.includes('another device') ||
        errorStr.includes('kicked') ||
        errorStr.includes('conflict') ||
        errorMsg.includes('already logged') ||
        errorMsg.includes('another device') ||
        errorMsg.includes('kicked') ||
        errorMsg.includes('conflict')
      ) {
        window.dispatchEvent(new CustomEvent('on-im-kicked-offline', { detail: error }))
      }
    },
    // 监听多端登录被踢下线
    onMultiDeviceEvent: function (event: any) {
      console.log('Multi device event:', event)
      if (event && (event.operation === 'kicked' || event.operation === 'conflict')) {
        window.dispatchEvent(new CustomEvent('on-im-kicked-offline', { detail: event }))
      }
    }
  })

  return conn
}

export const loginIM = (username: string, token: string) => {
    if (!conn) initIM()
    conn.open({
        user: username,
        accessToken: token // Or password/pwd depending on your auth method
    })
}

export const loginIMWithPassword = (username: string, password: string) => {
    if (!conn) initIM()
    conn.open({
        user: username,
        pwd: password
    })
}

export const sendPrivateMessage = (to: string, msg: string) => {
    if (!conn) return
    const id = conn.getUniqueId()                 // Generate local message id
    const message = new websdk.message('txt', id) // Create text message
    message.set({
        msg: msg,                  // Message content
        to: to,                    // Receiver
        chatType: 'singleChat',    // Chat type: singleChat, groupChat, chatRoom
        success: function (id: any, serverMsgId: any) {
            console.log('Send private text success')
            // Dispatch event for UI update if needed
            window.dispatchEvent(new CustomEvent('on-im-message-sent', { 
                detail: { id, serverMsgId, to, msg, from: conn.user, time: Date.now() } 
            }))
        },
        fail: function (e: any) {
            console.log('Send private text error', e)
        }
    })
    conn.send(message.body)
}

export const sendImageMessage = (to: string, fileData: any) => {
    if (!conn) return
    const id = conn.getUniqueId()
    const message = new websdk.message('img', id)
    
    // If it's a URL object (from our upload API)
    if (fileData.url) {
        message.set({
            to: to,
            chatType: 'singleChat',
            body: {
                type: 'img',
                url: fileData.url,
                filename: fileData.filename || 'image.png',
                file_length: fileData.file_length || 0,
                width: fileData.width || 0,
                height: fileData.height || 0
            },
            success: function (id: any, serverMsgId: any) {
                console.log('Send private image success')
                window.dispatchEvent(new CustomEvent('on-im-message-sent', { 
                    detail: { 
                        id, 
                        serverMsgId, 
                        to, 
                        msg: '[图片]', 
                        url: fileData.url,
                        type: 'img',
                        from: conn.user, 
                        time: Date.now() 
                    } 
                }))
            },
            fail: function (e: any) {
                console.log('Send private image error', e)
            }
        })
    } 
    // If it's a raw file object (letting SDK handle upload - though user asked for custom upload)
    // We will primarily use the URL method as per user request for custom upload API
    
    conn.send(message.body)
}

export const recallMessage = (serverMsgId: string, to: string) => {
  if (!conn) return
  conn.recallMessage({
    to: to,
    mid: serverMsgId,
    type: 'chat',
    success: function () {
      console.log('Message recall success')
      window.dispatchEvent(new CustomEvent('on-im-message-recall-success', { detail: { mid: serverMsgId, to } }))
    },
    fail: function (err: any) {
      console.log('Message recall failed', err)
    }
  })
}

export const getConn = () => conn
